export default __webpack_public_path__ + "static/media/15.48820ff5.png";